module.exports = __webpack_public_path__ + "img/image03_sp.90921129.jpg";